import CategoryAPI from "@api/lol/Category.api";
import type IProduct from "@api/models/IProduct";
import type { AppLolRegion } from "@core-types/region.enum";
import useAppLanguage from "@hooks/language/useAppLanguage";
import { useAppRegion } from "@hooks/region/useAppRegion";
import { useCallback, useEffect, useState } from "react";

export const useSmurfsNormal = () => {
  const [products, setProducts] = useState<IProduct[]>([]);
  const { changeRegion } = useAppRegion();
  const { lang } = useAppLanguage();

  const loadData = useCallback(() => {
    CategoryAPI.getBotsProducts().then((res) => {
      setProducts(res.data);
    });
  }, []);

  const handleRegionChange = (newRegion: AppLolRegion) => {
    changeRegion(newRegion, loadData);
  };

  useEffect(() => {
    loadData();
  }, [loadData, lang.currentLanguage]);

  return {
    products,
    handleRegionChange,
  };
};
